import React from "react";
import CreatableSelect from 'react-select/creatable';

class MoveToProjectComponent extends React.Component {
	constructor(props) {
		super(props);
		this.onProjectChange = this.onProjectChange.bind(this);
		var currentProject = '';
		if (this.props.currentItem !== undefined && this.props.currentItem.taskDetails.project !== undefined && this.props.currentItem.taskDetails.project !== null) {
			currentProject = this.props.currentItem.taskDetails.project.name;
		} else if (this.props.currentProject !== undefined) {
			currentProject = this.props.currentProject.name;
		}
		this.state = { currentProject };
	}

	onProjectChange(selected) {
		const value = selected ? selected.value : '';
		this.setState({ currentProject: value });
		this.props.onProjectChange(value);
	}

	render() {
		const options = this.props.projects.map(p => ({ value: p.name, label: p.name }));
		const value = this.state.currentProject
			? { value: this.state.currentProject, label: this.state.currentProject }
			: null;

		return (
			<CreatableSelect
				options={options}
				onChange={this.onProjectChange}
				value={value}
				isClearable
				placeholder="Select or type a project..."
				classNamePrefix="select"
			/>
		);
	}
}

export default MoveToProjectComponent;
